<template>
  <div class="py-6 px-4 pb-24 space-y-6" dir="rtl">
    <div class="max-w-2xl mx-auto space-y-6">
      
      <!-- Header -->
      <div class="bg-gradient-to-r from-purple-600 to-purple-700 rounded-2xl p-6 text-white">
        <div class="flex items-center justify-between mb-2">
          <h1 class="w-full text-2xl font-bold">پیوست‌ها</h1>
          <div v-if="req_code" class="flex items-center gap-2 bg-white bg-opacity-20 px-3 py-1.5 rounded-lg">
            <span class="text-md font-bold font-mono">{{ req_code }}</span>
          </div>
        </div>
        <p class="text-purple-100 text-sm">عکس‌های دستگاه را اضافه کنید</p>
      </div>

      <!-- File Upload Inputs -->
      <input 
        id="fileUploadGallery" 
        accept="image/*,video/*" 
        type="file" 
        hidden
        multiple
        v-on:change="input_file_changed('gallery')"
      >
      <input 
        id="fileUploadCamera" 
        accept="image/*" 
        type="file" 
        hidden
        capture="camera"
        v-on:change="input_file_changed('camera')"
      >
      <input 
        id="fileUploadVideo" 
        accept="video/*" 
        type="file" 
        hidden
        capture="camcorder"
        v-on:change="input_file_changed('video')"
      >

      <!-- Existing Attachments -->
      <div v-if="existing_attachments.length > 0" class="bg-white rounded-lg border border-gray-200 p-6">
        <h3 class="text-lg font-bold text-gray-800 mb-4">پیوست‌های قبلی</h3>
        <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div 
            v-for="item in existing_attachments" 
            :key="item.Id"
            class="bg-gray-50 rounded-xl border border-gray-200 p-3 hover:shadow-md transition-shadow cursor-pointer"
            @click="open_image(item.ImagePath)"
          >
            <div class="aspect-square rounded-lg overflow-hidden bg-white mb-2">
              <img :src="item.ImagePath" :alt="item.ImageName" class="w-full h-full object-cover" />
            </div>
            <p class="text-xs font-medium text-gray-700 truncate text-center">{{ item.ImageName }}</p>
          </div>
        </div>
      </div>

      <!-- Add File Section -->
      <div class="bg-white rounded-lg border border-gray-200 p-6 cursor-pointer hover:shadow-md transition-all duration-200 active:scale-95" @click="show_selection_menu = true">
        <div class="flex items-center justify-between group">
          <div class="flex items-center gap-3">
            <img src="/img/svg/add-circle.svg" alt="Add" class="w-6 h-6">
            <span class="text-gray-900 font-medium">افزودن عکس/ویدئو</span>
          </div>
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-5 h-5 text-gray-400 group-hover:text-gray-600 transition-colors">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
          </svg>
        </div>
      </div>

      <!-- Selection Menu Modal -->
      <div v-if="show_selection_menu" class="fixed inset-0 z-999">
        <div class="absolute inset-0 bg-black bg-opacity-60" @click="show_selection_menu = false"></div>
        <div class="relative z-10 flex h-full w-full items-center justify-center p-4">
          <div class="w-full max-w-md bg-white rounded-2xl shadow-xl overflow-hidden">
            <div class="px-6 py-5 border-b border-gray-200">
              <h3 class="text-xl font-bold text-gray-900 text-center">انتخاب منبع</h3>
            </div>
            <div class="p-6 space-y-3">
              <!-- Camera Button -->
              <button
                @click="open_camera()"
                class="w-full bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white py-4 px-6 rounded-xl font-bold text-lg transition-all duration-200 flex items-center justify-center gap-3 shadow-md hover:shadow-lg transform hover:scale-102"
              >
              <span class="w-full">عکس از دوربین</span>

                <div class="w-12 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                  <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
              </button>
              <!-- Gallery Button -->
              <button
                @click="open_gallery()"
                class="w-full bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 text-white py-4 px-6 rounded-xl font-bold text-lg transition-all duration-200 flex items-center justify-center gap-3 shadow-md hover:shadow-lg transform hover:scale-102"
              >
                <span class="w-full">گالری</span>

                <div class="w-12 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                  <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                </div>
              </button>
              
              <!-- Video Button -->
              <!-- <button
                @click="open_video()"
                class="w-full bg-gradient-to-r from-gray-500 to-gray-600 hover:from-gray-600 hover:to-gray-700 text-white py-4 px-6 rounded-xl font-bold text-lg transition-all duration-200 flex items-center justify-center gap-3 shadow-md hover:shadow-lg transform hover:scale-102"
              >
              <span class="w-full">فیلم از دوربین</span>

                <div class="w-12 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                  <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                  </svg>
                </div>
              </button> -->
              
              
            </div>
            <div class="px-6 py-4 border-t border-gray-200">
              <button
                @click="show_selection_menu = false"
                class="w-full py-3 bg-gray-100 text-gray-700 rounded-xl font-medium hover:bg-gray-200 transition-colors"
              >
                انصراف
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Files Grid -->
      <div v-if="files.length > 0" class="bg-white rounded-2xl border border-gray-200 p-6">
        <h3 class="text-lg font-bold text-gray-700 mb-4">فایل‌های انتخاب شده</h3>
        <div class="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-4">
          <div
            v-for="(item, i) in files"
            :key="i"
            class="relative group"
          >
            <!-- Delete Button -->
            <button
              v-on:click="delete_file(i)"
              class="absolute -top-2 -right-2 w-6 h-6 bg-red-500 text-white rounded-full flex items-center justify-center hover:bg-red-600 transform hover:scale-110 transition-all z-10"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            
            <!-- Upload Progress -->
            <div v-if="item.upload === 0 && item.uploadProgress > 0" class="absolute inset-0 bg-black bg-opacity-50 rounded-xl flex items-center justify-center">
              <div class="w-full px-2">
                <div class="w-full bg-gray-700 rounded-full h-2">
                  <div 
                    class="bg-green-500 h-2 rounded-full transition-all duration-300" 
                    :style="{ width: item.uploadProgress + '%' }"
                  ></div>
                </div>
                <p class="text-white text-xs text-center mt-1">{{ item.uploadProgress }}%</p>
              </div>
            </div>
            
            <!-- Upload Status Icons -->
            <div v-if="item.upload === 1" class="absolute top-2 left-2 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <div v-if="item.upload === 2" class="absolute top-2 left-2 w-6 h-6 bg-red-500 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            
            <!-- Image/Video Preview -->
            <div class="bg-gray-100 rounded-xl overflow-hidden border-2 border-gray-200 hover:border-purple-300 transition-colors">
              <img 
                v-if="item.file && item.file.startsWith('data:image')"
                loading="lazy" 
                :src="item.file" 
                class="w-full h-24 object-cover"
              />
              <video 
                v-else-if="item.file && item.file.startsWith('data:video')"
                :src="item.file"
                class="w-full h-24 object-cover"
              ></video>
              <div 
                v-else
                class="w-full h-24 bg-gray-200 flex items-center justify-center"
              >
                <svg class="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Send Button -->
      <button
        v-if="files.length > 0"
        v-on:click="save()"
        class="w-full bg-gradient-to-r from-purple-600 to-purple-700 text-white py-4 px-6 rounded-xl font-bold text-lg hover:shadow-xl transform hover:scale-102 transition-all"
      >
        {{$t('sendFiles')}}
      </button>

    </div>

    <!-- Camera Modal -->
    <div v-if="dialog_camera" class="fixed inset-0 z-999">
      <div class="absolute inset-0 bg-black bg-opacity-80" @click="dialog_camera = false"></div>
      <div class="relative z-10 flex flex-col h-full">
        <!-- Toolbar -->
        <div class="bg-gradient-to-r from-purple-600 to-purple-700 px-4 py-3 text-white flex items-center justify-between">
          <button
            @click="dialog_camera = false"
            class="w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center hover:bg-white hover:bg-opacity-30"
          >
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          <h2 class="text-lg font-bold">{{$t('camera')}}</h2>
          <button
            @click="downloadImage()"
            class="px-4 py-2 bg-white bg-opacity-20 rounded-lg hover:bg-white hover:bg-opacity-30 font-medium"
          >
            {{$t('save')}}
          </button>
        </div>

        <!-- Camera View -->
        <div v-if="isCameraOpen" class="flex-1 flex items-center justify-center bg-black relative">
          <video v-show="!isPhotoTaken" ref="camera" :width="450" :height="337.5" autoplay class="max-w-full max-h-full"></video>
          <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="450" :height="337.5" class="max-w-full max-h-full"></canvas>
        </div>

        <!-- Camera Controls -->
        <div v-if="isCameraOpen" class="bg-black px-4 py-6">
          <div class="flex justify-center">
            <button type="button" class="button" @click="takePhoto">
              <div class="w-16 h-16 bg-white rounded-full flex items-center justify-center hover:shadow-xl">
                <svg class="w-8 h-8 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
            </button>
          </div>
        </div>

        <div v-if="isPhotoTaken && isCameraOpen" class="camera-download">
          <!-- Additional download options can be added here -->
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {bus} from '../../main'

  export default {
    name: 'Attachments',
    data() {
      return {
        files: [],
        items: [
          {
            title: 'گالری',
          },
        ],
        dialog_camera: false,
        isCameraOpen: false,
        isPhotoTaken: false,
        show_selection_menu: false,
        req_code: '',
        existing_attachments: []
      }
    },
    mounted() {
      this.items = [
        {
          title: this.$t('gallery'),
        },
      ];
      this.get_request_code()
      this.get_attachs()
      // console.log("rec id",this.$route.params.rec_id)
    },
    watch: {},
    methods: {
      get_request_code() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          ExpertId: user_id,
          RequestId: this.$route.params.rec_id,
        }
        this.axios.post('/GetRequestInfoByReqId', send_data, {
          show_pros: false // Disable full-screen loading
        })
          .then(response => {
            if (response.data.error == 0 && response.data.rec) {
              self.req_code = response.data.rec.RequestCode || ''
            }
          }).catch(e => {
          // Silently fail - request code is optional
          console.log('Error getting request code:', e)
        })
      },
      get_attachs() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          ReqId: this.$route.params.rec_id,
          IsFinalize: 1,
        }
        this.axios.post('/GetUserRequestImages', send_data, {
          show_pros: false // Disable full-screen loading
        })
          .then(response => {
            if (response.data.error == 0) {
              self.existing_attachments = response.data.results || [];
              // Add https:// prefix if not present
              self.existing_attachments.forEach(function(item) {
                if (item.ImagePath && !item.ImagePath.startsWith('http')) {
                  item.ImagePath = 'https://' + item.ImagePath;
                }
              });
            }
          }).catch(e => {
          // Silently fail - attachments loading is optional
        })
      },
      open_image(img) {
        window.open(img, '_blank')
      },
      save() {
        if (this.files.length) {
          this.upload_image(0)

          for (var i = 0; i < this.files.length; i++) {
          }
        } else {
          this.$router.push({name: 'signature', params: {rec_id: this.$route.params.rec_id, type_id: 4}})
        }
      },
      open_camera() {
        this.show_selection_menu = false
        document.getElementById('fileUploadCamera').click()
      },
      open_video() {
        this.show_selection_menu = false
        document.getElementById('fileUploadVideo').click()
      },
      open_gallery() {
        this.show_selection_menu = false
        document.getElementById('fileUploadGallery').click()
      },
      select_file() {
        // Legacy method - kept for compatibility
        this.show_selection_menu = true
      },
      open_camera_dialog() {
        this.isCameraOpen = true
        this.createCameraElement()
      },
      delete_file(index) {
        this.files.splice(index, 1)
      },
      takePhoto() {
        this.isPhotoTaken = true

        const context = this.$refs.canvas.getContext('2d')
        context.drawImage(this.$refs.camera, 0, 0, 450, 337.5)
      },
      downloadImage() {
        if (this.isPhotoTaken == true) {
          this.isCameraOpen = false
          // const download = document.getElementById("downloadPhoto");
          const preview = document.getElementById('photoTaken')
          const canvas = document.getElementById('photoTaken').toDataURL('image/jpeg')
          // .replace("image/jpeg", "image/octet-streamLexicalAmbiguity(14, 19 threads"preview": preview, "upload": 0}
          this.files.push(obj)
          this.dialog_camera = false
          this.isPhotoTaken = false
        }
        // download.setAttribute("href", canvas);
      },
      input_file_changed(source) {
        var self = this
        var inputElement
        
        // Determine which input was used
        if (source === 'camera') {
          inputElement = document.getElementById('fileUploadCamera')
        } else if (source === 'video') {
          inputElement = document.getElementById('fileUploadVideo')
        } else {
          inputElement = document.getElementById('fileUploadGallery')
        }
        
        var files = inputElement.files
        if (!files || files.length === 0) return
        
        var totalFiles = files.length
        var processedFiles = 0
        var addedFiles = 0
        
        // Handle multiple files from gallery
        for (var i = 0; i < files.length; i++) {
          (function(index) {
            var file = files[index]
            var reader = new FileReader()
            
            reader.onloadend = function() {
              processedFiles++
              var result = reader.result
              
              // Check if it's a video
              if (file.type.startsWith('video/')) {
                var obj = {
                  file: result, 
                  preview: result, 
                  upload: 0,
                  uploadProgress: 0,
                  type: 'video',
                  name: file.name
                }
                self.files.push(obj)
                addedFiles++
                
                // Show message when all files are processed (for videos)
                if (processedFiles === totalFiles) {
                  if (addedFiles > 0) {
                    if (addedFiles === 1) {
                      bus.$emit('show_toast', [2000, '1 فایل اضافه شد'])
                    } else {
                      bus.$emit('show_toast', [2000, addedFiles + ' فایل اضافه شد'])
                    }
                  }
                }
              } else if (!result.startsWith('data:image/webp')) {
                // Resize image
                self.resizeBase64Img(result, 700, 700).then(function (newImg) {
                  var obj = {
                    file: newImg[0].src, 
                    preview: result, 
                    upload: 0,
                    uploadProgress: 0,
                    type: 'image',
                    name: file.name
                  }
                  self.files.push(obj)
                  addedFiles++
                  
                  // Show message when all files are processed
                  if (processedFiles === totalFiles) {
                    if (addedFiles > 0) {
                      if (addedFiles === 1) {
                        bus.$emit('show_toast', [2000, '1 فایل اضافه شد'])
                      } else {
                        bus.$emit('show_toast', [2000, addedFiles + ' فایل اضافه شد'])
                      }
                    }
                  }
                }).catch(function() {
                  bus.$emit('show_toast', [2000, 'خطا در پردازش ' + file.name])
                  if (processedFiles === totalFiles) {
                    if (addedFiles > 0) {
                      bus.$emit('show_toast', [2000, addedFiles + ' فایل اضافه شد'])
                    }
                  }
                })
              } else {
                bus.$emit('show_toast', [1500, self.$t('fileIsNotGranted')])
                
                // Check if all files are processed
                if (processedFiles === totalFiles) {
                  if (addedFiles > 0) {
                    bus.$emit('show_toast', [2000, addedFiles + ' فایل اضافه شد'])
                  }
                }
              }
            }
            
            reader.onerror = function() {
              processedFiles++
              bus.$emit('show_toast', [2000, 'خطا در خواندن فایل ' + file.name])
              
              if (processedFiles === totalFiles) {
                if (addedFiles > 0) {
                  bus.$emit('show_toast', [2000, addedFiles + ' فایل اضافه شد'])
                }
              }
            }
            
            reader.readAsDataURL(file)
          })(i)
        }
        
        // Reset input
        inputElement.value = ''
      },

      createCameraElement() {
        try {
          const constraints = (window.constraints = {
            audio: false,
            video: true
          })

          navigator.mediaDevices
            .getUserMedia(constraints)
            .then(stream => {
              this.$refs.camera.srcObject = stream
            })
            .catch(error => {
              alert(this.$t('deviceHasNoCamera'))
            })
        } catch (err) {
          alert(err)
        }
      },
      async resizeBase64Img(base64, minimum) {
        // try {

          var canvas = document.createElement('canvas')

          var deferred = $.Deferred()
          $('<img/>').attr('src', base64).load(function () {
            var last_width = this.width
            var last_height = this.height

            if (last_width > last_height) {
              last_width = (last_width * minimum) / last_height
              last_height = minimum
            } else {
              last_height = (last_height * minimum) / last_width
              last_width = minimum
            }
            canvas.width = last_width
            canvas.height = last_height
            var context = canvas.getContext('2d')

            console.log(this.width, this.height)
            context.scale(last_width / this.width, last_height / this.height)
            context.drawImage(this, 0, 0)

            deferred.resolve($('<img/>').attr('src', canvas.toDataURL()))
          })
          return deferred.promise()
        // } catch (e) {
        //   bus.$emit('show_toast', [3000, "error on Base64Img"])
        //
        // }
      },
      upload_image(index) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var form_data = new FormData()
        form_data.append('UserId', user_id)
        form_data.append('ProcessId', this.$route.params.rec_id)
        
        // Set Format based on file type: mp4 for video, png for image
        var format = this.files[index].type === 'video' ? 'mp4' : 'png'
        form_data.append('Format', format)
        form_data.append('ReqType', 6)
        
        // Set DocType based on file type: 0 for video, 1 for image
        var docType = this.files[index].type === 'video' ? 0 : 1
        form_data.append('DocType', docType)
        
        var my_file = this.files[index].file

        // Determine file extension based on type
        var fileExtension = 'png'
        var fileName = 'attach.png'
        if (this.files[index].type === 'video') {
          fileExtension = 'mp4'
          fileName = 'attach.mp4'
        }

        var file = this.dataURLtoFile(my_file, fileName)
        form_data.append('Picture', file)

        // Initialize upload progress
        self.$set(self.files[index], 'uploadProgress', 0)

        // Configure axios with progress tracking and disable full-screen loading
        this.axios.post('UploadFile', form_data, {
          show_pros: false, // Disable full-screen loading for file uploads
          onUploadProgress: function(progressEvent) {
            if (progressEvent.lengthComputable) {
              var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
              self.$set(self.files[index], 'uploadProgress', percentCompleted)
            }
          }
        })
          .then(response => {
            if (response.data.error == 0) {
              self.$set(self.files[index], 'upload', 1)
              self.$set(self.files[index], 'uploadProgress', 100)
              self.$set(self.files[index], 'ArchiveId', response.data.ArchiveId)
              self.$set(self.files[index], 'ImageName', response.data.ImageName)
              
              if (index < self.files.length - 1) {
                self.upload_image(index + 1)
              } else {
                self.send_attach()
              }
            } else {
              self.$set(self.files[index], 'upload', 2)
              self.$set(self.files[index], 'uploadProgress', 0)
              bus.$emit('show_toast', [1500, response.data.msg])
            }
          }).catch(e => {
          self.$set(self.files[index], 'upload', 2)
          self.$set(self.files[index], 'uploadProgress', 0)
          this.errors.push(e)
        })
      },
      dataURLtoFile(dataurl, filename) {
        try {

          var arr = dataurl.split(',')
          var mime = arr[0].match(/:(.*?);/)[1]
          var bstr = atob(arr[1])
          var n = bstr.length
          var u8arr = new Uint8Array(n)

          while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
          }

          return new File([u8arr], filename, {type: mime})
        } catch (e) {
          bus.$emit('show_toast', [3000, "error on dataURLtoFile"])

        }
      },

      send_attach() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        // console.log();

        var attachment_array = []

        self.files.forEach(function (number) {
          var pre_obj = {
            ArchiveId: number.ArchiveId,
            ImageName: number.ImageName,
            Summary: '',
          }
          attachment_array.push(pre_obj)
        })

        const send_data = {
          Attachments: attachment_array,
          UserId: user_id,
          ProcessId: this.$route.params.rec_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/AddRequestAttach', send_data, {
          show_pros: false // Disable full-screen loading
        })
          .then(response => {
            if (response.data.error == 0) {
              self.$router.push({name: 'signature', params: {rec_id: self.$route.params.rec_id, type_id: 4}})
            } else {
              bus.$emit('show_toast', [2000, response.data.msg + " " + JSON.stringify(send_data)])
            }
          }).catch(e => {
          this.errors.push(e)
        })
      }

    }
  }
</script>
<style>

</style>